import React, { useRef, useState } from "react";
import InnerLayout from "../../../layouts/inner-layout";

import { Navigate, useNavigate } from "react-router-dom";
import { ChevronLeftIcon, FileJson, Search } from "lucide-react";
import LoadingOverlay from "../../../helper-components/overlay-loading";
import {
    downloadAllTemplates,
    downloadAllTemplatesJson,
} from "../../../helper-components/helper-function";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import excelImg from "../../../../assets/icons/excel.png";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import successToast from "../../../helper-components/success-toast";
import DownloadIcon from "../../../../assets/icons/download-icon";

import {
    serverDocumentUploadAction,
} from "../../../../redux/actions/settings-action";

import errorToast from "../../../helper-components/error-toast";

import ServerComp from "./components/server-comp";

function Server() {
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const navigate = useNavigate();

    const server = [
        {
            documentType: "Server",
            expectedHeaders: ["server_id", "server_name", "customer_id"],
        },
    ];

    const itemTemplate = server;

    const actionType = serverDocumentUploadAction;

    const { handleFileUpload } = useCsvUpload(
        actionType,
        itemTemplate?.[0]?.expectedHeaders
    );

    const onSuccess = (data) => {
        successToast(data?.data?.message);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    return (
        <InnerLayout title="Settings">
            <div className="flex flex-col gap-2 mx-6 mt-4">
                <LoadingOverlay loading={loading} />

                <div className="flex justify-between items-center">
                    <div className=" flex items-center gap-2 text-sml ">
                        <button
                            className="flex items-center gap-2"
                            onClick={() => {
                                navigate("/settings");
                            }}
                        >
                            <ChevronLeftIcon className="h-5 w-5 inline-block " />
                            Data Setup Settings /
                        </button>
                        <span className="cursor-pointer">{" " + "Server"}</span>
                    </div>
                    <div className="flex items-center gap-3 pr-3">
                        {/* Temporarily hidden - Search, Import, and Download functionality */}
                        {/* <div
              style={{ minWidth: "18rem", height: "2.5rem" }}
              className={`border border-[var(--search-input-border)] flex  justify-between items-center rounded-md  w-10 `}
            >
              <input
                placeholder={`Search (/)`}
                className=" table_search_input px-3 py-2 !border-none !outline-none !ring-0 text-[length:var(--search-label-font-size)] font-[var(--search-place-font-weight)]"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e?.target?.value);
                }}
              />
              <span className="px-2">
                {" "}
                {<Search size="16" color="#9CA3AF" />}
              </span>
            </div>
            <div className=" flex flex-row gap-3">
              <div>
                <input
                  type="file"
                  accept=".csv,.json"
                  onChange={(e) => handleFileUpload(e, onSuccess, onError)}
                  className="hidden"
                  id="csv-upload"
                />
                <label htmlFor="csv-upload">
                  <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                    <img
                      width={20}
                      height={30}
                      src={excelImg}
                      alt="excel-icon"
                    />
                    <FileJson width={20} height={20} className="flex-shrink-0" />
                    {loading ? (
                      <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                    ) : (
                      <span>Import CSV / JSON</span>
                    )}
                  </div>
                </label>
              </div>
              <span title="Download CSV Template">
                <button
                  type="button"
                  onClick={() => {
                    downloadAllTemplates(itemTemplate);
                  }}
                  className="border-027A48 border-2 rounded-md px-2 py-2"
                >
                  <DownloadIcon fill="var(--success-color)" />
                </button>
              </span>
              <span title="Download JSON Template">
                <button
                  type="button"
                  onClick={() => {
                    downloadAllTemplatesJson(itemTemplate);
                  }}
                  className="border-027A48 border-2 rounded-md px-2 py-2"
                >
                  <DownloadIcon fill="var(--success-color)" />
                </button>
              </span>
            </div> */}
                    </div>
                </div>
                <div>
                    <ServerComp
                        pageLoading={loading}
                        setPageLoading={setLoading}
                        searchValue={searchValue}
                        reload={reload}
                        setReload={setReload}
                    />
                </div>
            </div>
        </InnerLayout>
    );
}

export default Server;
